import styled from 'styled-components'

export const RenderPriceContainer = styled.span`
	display: inline-block;
	word-break: break-word;
`
